import { Organization, Tenant } from 'src/types'

import api, { make, Response } from '.'

type ResponseGetTenants = {
  tenants: {
    page: number
    tenants: Tenant[]
    total_pages: number
    total_results: number
  }
}

type ResponsePostTenant = {
  tenant_id: number
  organizations: { organization_id: number }[]
}

export type TenantToSave = {
  tenant_setup: {
    tenant_id?: string
    tenant_organization_name: string
    tenant_sufix: string
  }
  organizations: Organization[]
}

const PAGE_SIZE = 1000

export function getAll(): Promise<Response<Tenant[]>> {
  return make<ResponseGetTenants, Tenant[]>({
    axiosCall: api.get(
      `/organizations/1/tenants?page_size=${PAGE_SIZE}&page=1`
    ),
    transformData: data => data.tenants.tenants
  })
}

export function save(
  tenant: TenantToSave
): Promise<Response<ResponsePostTenant>> {
  return make<ResponsePostTenant>({
    axiosCall: api.post(`/util/tools/create/tenants`, tenant)
  })
}
